import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';
import {QuestionsAndAnswers, QuestionAndAnswer} from '@udemy/react-frequently-asked-questions';
import {ContentArea, ContentGrid, ContentGridItem} from '@udemy/react-layout-components';

import styles from './academies-faq.module.less';

interface FrequentlyAskedQuestionsProps {
    questionsAndAnswers: QuestionAndAnswer[];
}

export const FrequentlyAskedQuestions = ({
    questionsAndAnswers,
}: FrequentlyAskedQuestionsProps): JSX.Element | null => {
    const {gettext} = useI18n();

    if (questionsAndAnswers.length === 0) {
        return null;
    }

    return (
        <div className={styles['section-parent-container']}>
            <h2 className={styles['faq-title']}>{gettext('Frequently asked questions')}</h2>
            <ContentArea className={classNames('ud-container', styles['area'])}>
                <ContentGrid>
                    <ContentGridItem defaultColumn={'1 / span 4'} mdColumn={'2 / span 10'}>
                        <div className={styles['faq-container']}>
                            <QuestionsAndAnswers
                                title={''}
                                className={styles['faq-inner-container']}
                                questionsAndAnswers={questionsAndAnswers}
                                numRowsToShow={4}
                                showMoreClass={styles['show-more-btn']}
                                showMoreStyle={'link'}
                                showMoreHasCount={true}
                                showButtonIcon={true}
                            />
                        </div>
                    </ContentGridItem>
                </ContentGrid>
            </ContentArea>
        </div>
    );
};
